export const normalizeTargetScopeIds = (items = []) =>
  items
    .map(item => item?.id ?? item?.parent_entity ?? item)
    .filter(item => item !== undefined && item !== null)
